import {BASE_DOMINIOS} from "utils/constants";

export const ConfigUtils = {
    verifyDominio : (dominio: string): boolean => {
        return BASE_DOMINIOS.some((item) => item === dominio);
    }
}